import { createStore, applyMiddleware, combineReducers } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import Elements from './reducers/elements';
import Users from './reducers/users';

// const middleware = applyMiddleware(thunk);
const middleware = process.env.NODE_ENV === 'development' ? applyMiddleware(thunk, logger) : applyMiddleware(thunk);

const reducers = combineReducers({
  elements: Elements,
  users: Users,
});

export default createStore(reducers, middleware);



// WEBPACK FOOTER //
// ./src/store.js